// List answers of the backend (common/helpers/pagination.helper.ts), as `api()` hands them to callers.

/** Offset meta, for the small admin lists (users, locations, gateways, OTA releases). */
export interface OffsetMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

/** A count that may be a lower bound: `exact` false means "more than `count`". */
export interface BoundedTotal {
  count: number;
  exact: boolean;
}

/**
 * Keyset meta, for the growing tables (audit, alerts, events, movements, gateway commands): `next` is the
 * `beforeId` of the older page, `prev` the `afterId` of the newer one; null at either end.
 */
export interface CursorMeta<K extends number | string = number> {
  limit: number;
  next: K | null;
  prev: K | null;
  total: BoundedTotal | null;
}

export interface OffsetPage<T> {
  items: T[];
  meta: OffsetMeta;
}
export interface CursorPage<T, K extends number | string = number> {
  items: T[];
  meta: CursorMeta<K>;
}

/** Where a keyset page starts: older than `beforeId`, newer than `afterId`, or the newest page (neither). */
export interface Cursor<K extends number | string = number> {
  beforeId?: K;
  afterId?: K;
}

/** `?a=1&b=x` from the values that are set (undefined, null and '' are left out). */
export function query(params: Record<string, string | number | boolean | null | undefined>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null && v !== '') p.set(k, String(v));
  const s = p.toString();
  return s ? `?${s}` : '';
}
